// Data seam for custom themes, mirroring src/data/notes.js.
//
// Org-wide like notes: one shared book, so a theme one person defines is the
// theme everybody sorts by. Assignments are keyed on the SYMBOL, not the
// position — a ticker held in two accounts is one asset with one theme.

import { request } from './portfolio';

/** Resolves to `{ themes, assignments }`, where assignments maps symbol ->
 *  theme id. An asset missing from it is "Not assigned". */
export const getThemes = () => request('themes');

export const createTheme = (name) =>
  request('themes', { method: 'POST', body: JSON.stringify({ name }) });

/** The server cascades: every asset that carried the theme is unassigned. */
export const deleteTheme = (id) =>
  request(`themes/${encodeURIComponent(id)}`, { method: 'DELETE' });

/** Assigns, replacing any existing theme, or unassigns with `themeId: null`.
 *  The symbol goes in the body because "BRK B" does not survive as a path. */
export const assignTheme = (symbol, themeId) =>
  request('themes/assignments', {
    method: 'PUT',
    body: JSON.stringify({ symbol, themeId }),
  });
